import type {
  ProductFilterTagCollectionCategoryPagedResult,
  ProductFilterTagCollectionPagedResult,
  ProductFilterTagPagedResult,
  ProductFilterTagWithCount,
} from '~/types/api'

export function createProductFilterTagRepository() {
  const { $api } = useNuxtApp()
  const { get } = baseRepository($api)

  const DOMAIN = 'product-filter-tags'
  const DOMAIN_CATEGORIES = 'product-filter-tag-collection-categories'
  const DOMAIN_COLLECTIONS = 'product-filter-tag-collections'

  async function getAllCategories() {
    return get<ProductFilterTagCollectionCategoryPagedResult>(
      [DOMAIN_CATEGORIES],
      {
        params: {
          sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
        },
      }
    )
  }

  async function getAllCollections(categoryId: number) {
    return get<ProductFilterTagCollectionPagedResult>([DOMAIN_COLLECTIONS], {
      params: {
        filter: APIFilters.makeFilter([
          {
            [APIFilterOP.EQUALS]: {
              'productFilterTagCollectionCategories.nid': categoryId,
            },
          },
        ]),
        sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
      },
    })
  }

  async function getAllTags(collectionId: number) {
    return get<ProductFilterTagPagedResult>([DOMAIN], {
      params: {
        filter: APIFilters.makeFilter([
          {
            [APIFilterOP.EQUALS]: {
              'productFilterTagCollections.nid': collectionId,
            },
          },
        ]),
        sort: APIFilters.makeSort({ weight: 'ASC', title: 'ASC' }),
      },
    })
  }

  async function getCollectionTagsWithCount(
    collectionId: number,
    tags: number[]
  ) {
    return get<ProductFilterTagWithCount[]>(
      [DOMAIN_COLLECTIONS, collectionId, 'public-filter-tags'],
      {
        params: {
          appliedFilterTags: tags,
        },
      }
    )
  }

  return {
    getAllCategories,
    getAllCollections,
    getAllTags,
    getCollectionTagsWithCount,
  }
}
